import React from 'react'
import { useDomainMessage } from 'domains/account-management/utils/domain/intl'
import { useAccountManagementRoles } from 'domains/account-management/components/role-select/utils/AccountManagementRoleSelect.hooks'
import { NewSelect } from '@retailer-platform/shared-components'

interface Props {
  onChange: (v: string | undefined) => void
  value: string | undefined
}

export const AccountManagementSimpleRoleSelect: React.FunctionComponent<Props> = ({
  value,
  onChange,
}) => {
  const { loading, primaryOptions } = useAccountManagementRoles({ useDefaultOption: false })
  const placeholder = useDomainMessage('accountManagementDomain.roles.placeholder')

  return (
    <NewSelect
      placeholder={placeholder}
      isLoading={loading}
      options={primaryOptions.map(({ label, value }) => ({ label, value }))}
      value={value}
      onChange={value => onChange(value)}
      isClearable
    />
  )
}
